import { AppError } from '@vk-hr-tek/ui/error';
import { Box } from '@vk-hr-tek/ui/Box';

import { SubmitError } from '../SubmitError';
import { SUBMIT_ERROR_TEXT } from '../form.constants';

/**
 * Свойства компонента {@link FormError}
 */
interface FormErrorProps {
  /**
   * Объект ошибки или null.
   */
  error: { description: string; traceId?: string | null } | null;
}

/**
 * Компонент для отображения ошибки формы.
 *
 * @public
 * @param error - Объект ошибки или null.
 * @returns Компонент для отображения ошибки формы.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link FormErrorProps}
 */
export const FormError = ({ error }: FormErrorProps) => (
  <Box pt="20">
    <SubmitError
      submitError={
        {
          title:
            error && error.description ? error.description : SUBMIT_ERROR_TEXT,
          traceId: error && error.traceId,
        } as AppError
      }
    />
  </Box>
);
